import React from "react";
import { format } from "date-fns";

import { Chip } from "@mui/material";

import BatchDetail from "../../../common/BatchDetail";
import ColumnHeader from "../../../common/ColumnHeader";
import { CLIENTS, getChipColor, getValidRetryLines } from "../../../../constants/value";
import { dateSortComparator } from "../../../../utils/date";
import { __getActivate } from "../../../../api/sim";

const COPY_KEYS = [
  "id",
  "batch_id",
  "iccid",
  "status",
  "plan_id",
  "plan",
  "trial_count",
  "areacode",
  "zipcode",
  "msisdn",
  "last_updated",
];

// Ultra Activate's own column shape (plan_id/plan/trial_count) doesn't match
// the shared activateColumns factory - kept local rather than force-fitting.
const activateColumns = ({ handleColumnClick, client }) => [
  { field: "id", headerName: "ID", flex: 1, sortable: false },
  {
    field: "iccid",
    headerName: "ICCID",
    minWidth: 200,
    flex: 3,
    sortable: false,
    renderHeader: () =>
      client ? (
        <ColumnHeader label="ICCID" handleClick={() => handleColumnClick("iccid")} />
      ) : (
        "ICCID"
      ),
  },
  {
    field: "status",
    headerName: "Status",
    minWidth: 120,
    flex: 2,
    sortable: false,
    renderCell: (params) => (
      <Chip label={params.row.status} size="small" color={getChipColor(params.row.status)} />
    ),
  },
  {
    field: "trial_count",
    headerName: "Trials",
    minWidth: 50,
    flex: 1,
    sortable: false,
    renderCell: (params) => <Chip label={`${params.row.trial_count}`} size="small" color="default" />,
  },
  { field: "plan_id", headerName: "Plan ID", flex: 1, sortable: false },
  { field: "plan", headerName: "Plan", minWidth: 250, flex: 4, sortable: false },
  { field: "areacode", headerName: "Areacode", minWidth: 75, flex: 1, sortable: false },
  { field: "zipcode", headerName: "Zipcode", minWidth: 75, flex: 1, sortable: false },
  {
    field: "msisdn",
    headerName: "MSISDN",
    minWidth: 100,
    flex: 2,
    sortable: false,
    renderHeader: () =>
      client ? (
        <ColumnHeader label="MSISDN" handleClick={() => handleColumnClick("msisdn")} />
      ) : (
        "MSISDN"
      ),
  },
  {
    field: "created_at",
    headerName: "Created At",
    minWidth: 200,
    filterable: false,
    flex: 3,
    sortable: false,
    valueGetter: (params) => params.row.created_at || null,
    valueFormatter: (params) =>
      params.value && `${format(new Date(params.value), "MMMM d, y hh:mm a")}`,
    sortComparator: dateSortComparator,
  },
  {
    field: "last_updated",
    headerName: "Last Updated",
    minWidth: 200,
    filterable: false,
    flex: 3,
    sortable: false,
    valueGetter: (params) => params.row.last_updated || null,
    valueFormatter: (params) =>
      params.value && `${format(new Date(params.value), "MMMM d, y hh:mm a")}`,
    sortComparator: dateSortComparator,
  },
];

const ActivateBatch = () => (
  <BatchDetail
    title="Activate"
    apiGet={__getActivate}
    client={CLIENTS.ultra}
    columnsFactory={activateColumns}
    copyKeys={COPY_KEYS}
    exportAction="activate"
    retryOperation="activate"
    showTerminate
    updateAndRetry={{ getValidRetryLines, path: "update" }}
    getRowPath={(row) => `/ultra/activate/${row.id}`}
  />
);

export default ActivateBatch;
